"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBucketNotificationConfigurationInput = {
    type: "structure",
    required: ["Bucket"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        }
    }
};
//# sourceMappingURL=GetBucketNotificationConfigurationInput.js.map